import { render, staticRenderFns } from "./party.vue?vue&type=template&id=72b83d7a&"
import script from "./party.vue?vue&type=script&lang=js&"
export * from "./party.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports